import ExpandableContentComponent from 'components/ExpandableContentComponent';
import { LearnerCourseOverview } from 'models/LearnerCourseOverview';
import LearnerCourseCard from './LearnerCourseCard';
import { CourseCardsContainer } from '../sharedStyles/LearnerStyles';
import { Headline2 } from 'components/Elements';

export default function ExpandableCourseList({
    headline,
    courses,
}: {
    headline: string | JSX.Element;
    courses: LearnerCourseOverview[];
}) {
    return (
        <>
            <ExpandableContentComponent
                headline={<Headline2>{headline}</Headline2>}
                closedHeightInPx={0}
                expandedByDefault={false}
                bigButton
                content={
                    <CourseCardsContainer>
                        {courses
                            .sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime())
                            .map((courseOverview: LearnerCourseOverview) => {
                                return (
                                    <LearnerCourseCard
                                        key={courseOverview.enrollmentId}
                                        courseOverview={courseOverview}
                                    />
                                );
                            })}
                    </CourseCardsContainer>
                }
            />
        </>
    );
}
